<template>
    <div class="swapconfirm"  v-if="1 === 0">
        <img src="../assets/images/close.svg" alt="close" class="close" @click="closePopup">
        <p class="title">스왑확인</p>
        <p class="review">전환되는 수량과 보내는 주소를 <span>다시 한번 확인해 주세요</span></p>
        <div class="network">
            <div class="ethereum">
                <p>보유수량 <span>(ERC - 20)</span></p>
                <p>500,000</p>
            </div>
            <img src="../assets/images/icon_change_arrow_pc.svg" alt="화살표"> 
            <div class="klaytn">
                <p>스왑될 수량 <span>(KCT)</span></p>
                <p>500,000</p>
            </div>
            <div class="adress">
                <p>주소</p>
                <p>0xec3012d50EEC2DD4a238cd5c41004FA2d6099095</p>
            </div>
        </div>
        <div class="swap_start" @click="swap_start">스왑 시작</div>
    </div>
</template>

<script>
export default{
    methods: {
        closePopup(){
            this.$emit('close');
        },
        swap_start(){
            if(this.PurpleGauge === true){
                document.getElementById('purpleguage2').setAttribute('class','line purple');
                document.getElementById('dot3').setAttribute('class','purple2');
                document.getElementById('chapter3').setAttribute('class','purple2');
            }
        },
    }
}
</script>